/**
 * 路由前置校验态枚举
 */
const ROUTE_REQUIRE_ENUM = {
  MUST_LOGIN: 0b001,
  HAS_CHILD: 0b011,
  SELF_CHILD: 0b111,
};

module.exports = {
  ROUTE_REQUIRE_ENUM,
};
